/* ==========================================================================
   Revalia Tart Cherry V2 — HBP / Menopause page behaviour (tce-hbp-meno-2)
   Vanilla port of the signed-off design prototype. No framework.
   Idempotent + theme-editor safe (guards + shopify:section:load re-init).
   Namespace: tce2- everywhere so it never collides with the V1 (.tcm) funnel.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* ---------------- 1. delivery date (today + N days, "Month Dayth") -------- */
  function initArrival(root) {
    $$('[data-tce2-arrival]', root).forEach(function (el) {
      var o = parseInt(el.getAttribute('data-tce2-arrival'), 10);
      var days = isNaN(o) ? 5 : o;
      var d = new Date(Date.now() + days * 86400000);
      var month = d.toLocaleDateString('en-US', { month: 'long' });
      var day = d.getDate();
      var s = (day % 10 === 1 && day !== 11) ? 'st'
            : (day % 10 === 2 && day !== 12) ? 'nd'
            : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
      el.textContent = month + ' ' + day + s;
    });
  }

  /* ---------------- 2. gallery carousel ---------------- */
  var gallery = { index: 0, count: 0 };

  function railCenter(i) {
    var rail = $('[data-tce2-rail]');
    if (!rail) return;
    var child = rail.children[i];
    if (!child) return;
    var target = child.offsetLeft - rail.clientWidth / 2 + child.clientWidth / 2;
    var max = rail.scrollWidth - rail.clientWidth;
    rail.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
  }

  function changeSlide(i) {
    var track = $('[data-tce2-track]');
    var thumbs = $$('[data-tce2-thumb]');
    if (!track) return;
    var n = gallery.count || thumbs.length;
    if (!n) return;
    i = ((i % n) + n) % n;                 // infinite wrap both directions
    gallery.index = i;
    track.style.transform = 'translateX(' + (-100 * i) + '%)';
    thumbs.forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      t.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
    railCenter(i);
  }

  function initCarousel(root) {
    var main = $('[data-tce2-carousel]', root);
    if (!main) return;
    var thumbs = $$('[data-tce2-thumb]', root);
    gallery.count = thumbs.length;
    gallery.index = 0;
    thumbs.forEach(function (t, i) {
      if (t.dataset.tce2Bound) return;
      t.dataset.tce2Bound = '1';
      t.addEventListener('click', function () { changeSlide(i); });
    });
    changeSlide(0);
  }

  // Gestures bound ONCE at document level, delegated via closest() so they
  // survive section re-render. Horizontal-intent lock; commit past 40px.
  function initGalleryGestures() {
    if (window.__tce2GalleryGestures) return;
    window.__tce2GalleryGestures = true;

    var THRESHOLD = 40, LOCK = 8;
    var inCarousel = function (t) { return t && t.closest && t.closest('[data-tce2-carousel]'); };
    var x0 = null, y0 = null, axis = null, mx0 = null;
    var commit = function (dx) {
      if (dx < -THRESHOLD) changeSlide(gallery.index + 1);
      else if (dx > THRESHOLD) changeSlide(gallery.index - 1);
    };

    document.addEventListener('touchstart', function (e) {
      if (!inCarousel(e.target)) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; axis = null;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (!axis && (Math.abs(dx) > LOCK || Math.abs(dy) > LOCK)) axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      if (axis === 'h' && e.cancelable) e.preventDefault();
    }, { passive: false });
    document.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      if (axis === 'h') commit(e.changedTouches[0].clientX - x0);
      x0 = null; y0 = null; axis = null;
    }, { passive: true });

    document.addEventListener('mousedown', function (e) {
      var el = inCarousel(e.target);
      if (!el) { mx0 = null; return; }
      mx0 = e.clientX; el.classList.add('is-grabbing'); e.preventDefault();
    });
    document.addEventListener('mouseup', function (e) {
      if (mx0 === null) return;
      commit(e.clientX - mx0); mx0 = null;
      var el = $('[data-tce2-carousel]'); if (el) el.classList.remove('is-grabbing');
    });
    document.addEventListener('dragstart', function (e) { if (inCarousel(e.target)) e.preventDefault(); });
  }

  /* ---------------- 3. review carousel (3 desktop / 1 mobile) ----------------
     Transform-driven: arrows/dots/swipe advance exactly one card, clamped to real
     positions (no empty overscroll). overflow:hidden -> no visible scrollbar. */
  function initReviewCarousel(root) {
    var vp = $('[data-tce2-reviews]', root);
    if (!vp) return;
    var track = $('[data-tce2-rev-track]', vp);
    var items = $$('.tce2-rev-item', vp);
    if (!track || !items.length) return;

    var wrap = vp.closest('.tce2-reviews-inner') || document;
    var dots = $$('[data-tce2-rev-dot]', wrap);
    var prev = $('[data-tce2-rev-prev]', wrap);
    var next = $('[data-tce2-rev-next]', wrap);
    var N = items.length;
    var state = { rp: 0 };

    function perView() { return (window.innerWidth <= 900) ? 1 : 3; }

    function render() {
      var pv = perView();
      var maxRp = Math.max(0, N - pv);
      if (state.rp > maxRp) state.rp = maxRp;
      // percent translate resolves against the element's OWN width, so divide by per-view
      track.style.transform = 'translateX(-' + (state.rp * (100 / pv)) + '%)';
      dots.forEach(function (d, k) {
        d.style.display = (k <= maxRp) ? 'block' : 'none';   // hide dots beyond real positions
        d.classList.toggle('is-active', k === state.rp);
      });
    }

    function step(dir) {
      var maxRp = Math.max(0, N - perView());
      state.rp = Math.min(maxRp, Math.max(0, state.rp + dir));
      render();
    }

    if (!vp.dataset.tce2Bound) {
      vp.dataset.tce2Bound = '1';
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          var maxRp = Math.max(0, N - perView());
          state.rp = Math.min(k, maxRp); render();
        });
      });

      // swipe / drag — one card per gesture, commit past 45px
      var rx = null, ry = null, rlock = false, rmx = null;
      var rCommit = function (dx) { if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1); };
      vp.addEventListener('touchstart', function (e) { rx = e.touches[0].clientX; ry = e.touches[0].clientY; rlock = false; }, { passive: true });
      vp.addEventListener('touchmove', function (e) {
        if (rx === null) return;
        var dx = e.touches[0].clientX - rx, dy = e.touches[0].clientY - ry;
        if (!rlock && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) rlock = true;
        if (rlock && e.cancelable) e.preventDefault();
      }, { passive: false });
      vp.addEventListener('touchend', function (e) { if (rx === null) return; rCommit(e.changedTouches[0].clientX - rx); rx = null; rlock = false; }, { passive: true });
      vp.addEventListener('mousedown', function (e) { rmx = e.clientX; vp.classList.add('is-grabbing'); e.preventDefault(); });
      window.addEventListener('mouseup', function (e) { if (rmx === null) return; rCommit(e.clientX - rmx); rmx = null; vp.classList.remove('is-grabbing'); });

      window.addEventListener('resize', render);
    }
    render();
  }

  /* ---------------- 4. accordions (animated, one-open-at-a-time) ---------------- */
  function closeAcc(d) {
    var s = d.querySelector('summary');
    var c = s && s.nextElementSibling;
    var icon = s && s.querySelector('.tce2-acc-plus');
    if (!c) return;
    c.style.height = c.scrollHeight + 'px';
    requestAnimationFrame(function () { c.style.height = '0px'; });
    if (icon) icon.style.transform = 'rotate(0deg)';
    c.addEventListener('transitionend', function () { d.removeAttribute('open'); }, { once: true });
  }

  function initAccordions(root) {
    $$('details[data-tce2-acc]', root).forEach(function (d) {
      var summary = d.querySelector('summary');
      var content = summary && summary.nextElementSibling;
      var icon = summary && summary.querySelector('.tce2-acc-plus');
      if (!summary || !content) return;

      content.style.overflow = 'hidden';
      content.style.transition = 'height 0.36s cubic-bezier(0.4,0,0.2,1)';
      if (!d.hasAttribute('open')) { content.style.height = '0px'; if (icon) icon.style.transform = 'rotate(0deg)'; }
      else { content.style.height = 'auto'; if (icon) icon.style.transform = 'rotate(45deg)'; }

      if (d.dataset.tce2Bound) return;
      d.dataset.tce2Bound = '1';

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.hasAttribute('open')) { closeAcc(d); return; }
        var group = d.parentElement;                     // one open at a time within the group
        if (group) $$(':scope > details[open]', group).forEach(function (o) { if (o !== d) closeAcc(o); });
        d.setAttribute('open', '');
        content.style.height = content.scrollHeight + 'px';
        if (icon) icon.style.transform = 'rotate(45deg)';
        content.addEventListener('transitionend', function () { if (d.hasAttribute('open')) content.style.height = 'auto'; }, { once: true });
      });
    });
  }

  /* ---------------- 5. scroll reveal (fade + rise, staggered) ---------------- */
  function initReveal(root) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var targets = $$('[data-tce2-reveal]', root);
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('tce2-reveal-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) {
      if (el.dataset.tce2RevealBound) return;
      el.dataset.tce2RevealBound = '1';
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;      // already in view -> leave visible
      el.classList.add('tce2-reveal');
      io.observe(el);
    });
  }

  /* ---------------- 6. mobile sticky CTA + scroll-to-ATC ---------------- */
  function initSticky() {
    var bar = $('[data-tce2-sticky]');
    if (bar) document.body.classList.add('tce2-has-sticky');

    var atc = $('.tce2-cta');
    if (bar && !bar.dataset.tce2RevealBound) {
      if (!atc || !('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');                 // no ATC to track -> never trap the user
      } else {
        bar.dataset.tce2RevealBound = '1';
        // show only once the real Add-to-Cart button has scrolled ABOVE the viewport
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var past = !en.isIntersecting && en.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', past);
          });
        }, { threshold: 0 }).observe(atc);
      }
    }

    // "Shop Now" + any in-page CTA scrolls the main ATC into the middle of the screen
    $$('[data-tce2-scroll-atc]').forEach(function (link) {
      if (link.dataset.tce2Bound) return;
      link.dataset.tce2Bound = '1';
      link.addEventListener('click', function (e) {
        var target = $('.tce2-cta');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center', inline: 'nearest' });
      });
    });
  }

  /* ---------------- 7. add to cart (AJAX so Kaching can intercept) ----------------
     Kaching Bundles intercepts the theme's cart-add AJAX and rewrites it into the
     full bundle. A native POST can't be intercepted (double-adds). So submit via
     fetch to /cart/add.js exactly like a theme, then navigate ourselves. */
  function initAtcForm() {
    var form = $('[data-tce2-atc-form]');
    if (!form || !window.fetch || form.dataset.tce2Bound) return;
    form.dataset.tce2Bound = '1';
    // bfcache fix: re-enable the ATC button after a back-navigation restore (else it stays disabled)
    window.addEventListener('pageshow', function () { var b = form.querySelector('.tce2-cta'); if (b) b.disabled = false; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.tce2-cta');
      if (btn) btn.disabled = true;
      var dest = form.getAttribute('data-tce2-checkout') === 'true' ? '/checkout' : '/cart';
      var data = new FormData(form);
      data.delete('return_to');
      var go = function () { window.location.href = dest; };
      fetch('/cart/add.js', {
        method: 'POST', body: data,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      }).then(go).catch(function () { if (btn) btn.disabled = false; form.submit(); });
    });
  }

  /* Kaching writes the selected bundle price into the CTA but never the compare-at.
     Mirror the selected bundle's strikethrough ("was") price onto the button. */
  function initKachingCompare() {
    var cmp = document.querySelector('[data-tce2-cart-compare]');
    if (!cmp) return;
    var kb = document.querySelector('kaching-bundle');
    if (!kb) {
      if (window.__tce2KachingWait) return;
      window.__tce2KachingWait = true;
      var tries = 0;
      var iv = setInterval(function () {
        if (document.querySelector('kaching-bundle')) { clearInterval(iv); window.__tce2KachingWait = false; initKachingCompare(); }
        else if (++tries > 40) { clearInterval(iv); window.__tce2KachingWait = false; }
      }, 500);
      return;
    }
    if (kb.dataset.tce2CmpBound) return;
    kb.dataset.tce2CmpBound = '1';
    var desired = '';
    var read = function () {
      var sel = kb.querySelector('.kaching-bundles__bar--selected');
      var full = sel && sel.querySelector('.kaching-bundles__bar-full-price');
      return full ? full.textContent.trim() : '';
    };
    var sync = function () {
      desired = read();
      if (cmp.textContent.trim() !== desired) cmp.textContent = desired;
      cmp.style.display = desired ? '' : 'none';
    };
    sync();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 60); })
      .observe(kb, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    kb.addEventListener('click', function () { setTimeout(sync, 80); });
    new MutationObserver(function () {
      if (cmp.textContent.trim() !== desired) { cmp.textContent = desired; cmp.style.display = desired ? '' : 'none'; }
    }).observe(cmp, { childList: true, characterData: true, subtree: true });
  }

  /* ---------------- boot ---------------- */
  function init(root) {
    root = root || document;
    initArrival(root);
    initCarousel(root);
    initReviewCarousel(root);
    initAccordions(root);
    initReveal(root);
    initSticky();
    initAtcForm();
    initKachingCompare();
    initGalleryGestures();
  }

  function boot() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
  }

  if (!window.__tce2Init) {
    window.__tce2Init = true;
    boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function () {
      document.body.classList.toggle('tce2-has-sticky', !!$('[data-tce2-sticky]'));
    });
  }
})();
